import React from "react";
import type { TokenVolumeSliceResult } from "../../models/tokenVolume";

export function TokenVolumePanel({ result, mode }: { result: TokenVolumeSliceResult; mode: "monitor" | "forecast" }) {
  if (mode === "monitor") {
    return (
      <div className="model-panel-table">
        <p>全球绝对量是结构估计；OpenRouter 是单平台实测窗口，两者不做市场份额放大。</p>
        <table>
          <thead><tr><th>任务</th><th>形态</th><th>月 Token</th><th>占比</th></tr></thead>
          <tbody>{result.estimate.taskMix.map((row) => (
            <tr key={`${row.task}-${row.surface}`}><td>{row.task}</td><td>{row.surface}</td><td>{row.tokensT.toFixed(1)}T</td><td>{row.sharePct.toFixed(1)}%</td></tr>
          ))}</tbody>
        </table>
      </div>
    );
  }
  return (
    <div className="model-panel-table">
      <p>{result.backtest.promotionGate.reason}</p>
      <table>
        <thead><tr><th>候选</th><th>OOS</th><th>1M RMSE</th><th>1–12M direct RMSE</th><th>MAPE</th></tr></thead>
        <tbody>{Object.values(result.backtest.candidates).map((model) => (
          <tr key={model.id}><td>{model.label}</td><td>{model.metrics.full.observations}</td><td>{model.metrics.full.rmse.toFixed(2)}T</td><td>{model.metrics.direct1To12.rmse.toFixed(2)}T</td><td>{model.metrics.full.mape.toFixed(1)}%</td></tr>
        ))}</tbody>
      </table>
    </div>
  );
}
